<template>
  <div class="hello">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      :router="true"
      background-color="#2850a0"
      text-color="#fff"
      active-text-color="#fff"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="/main/index"
        ><i class="iconfont icon-home"></i>
        <span slot="title">首页</span></el-menu-item
      >
      <el-menu-item index="/main/seal/management"
        ><i class="iconfont icon-yinzhangguanli"></i>
        <span slot="title">印章管理</span></el-menu-item
      >
      <!-- index="/main/application" -->
      <el-menu-item index="/main/application"
        ><i class="iconfont icon-qianzhang"></i>
        <span slot="title" >应用服务</span></el-menu-item
      >
      <!-- index="/main/focus/news" -->
      <el-menu-item index="/main/focus/news" 
        ><i class="iconfont icon-Shapex" ></i>
        <span slot="title" >要闻动态</span></el-menu-item
      >

      <!-- <el-menu-item index="/main/signature"
        ><i class="iconfont icon-qianzhang"></i>
        <span slot="title">我要签章</span></el-menu-item
      >
      <el-menu-item index="/main/verification"
        ><i class="iconfont icon-yanqian"></i>
        <span slot="title">我要验签</span></el-menu-item
      >

      <el-menu-item index="/main/certificat/emanagement"
        ><i class="iconfont icon-zhengshuguanli"></i>
        <span slot="title">证书管理</span></el-menu-item
      >
      <el-menu-item index="/main/log/management"
        ><i class="iconfont icon-rizhiguanli"></i>
        <span slot="title">日志管理</span></el-menu-item
      > -->
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "navBar",
  data() {
    return {
      msg: "",
      activeIndex: "/main/index",
      barShow: true,
    };
  },
  methods: {
    goToAppServes() {
      this.$message.error('该功能暂未开放');
    },
    //切换导航栏
    handleSelect(e) {
    },
  },
  created() {},
  getTs() {
    this.$message.error("该功能暂未开放");
  },
  mounted() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (!userInfo) {
      this.barShow = false;
    } else {
      this.barShow = true;
    }
    // this.$http.post('/login/isLogin.shtml',{token:''}).then(res=>{
    //   let {code,data,msg} =res.data
    //   if(code == 0){

    //   }else{

    //   }
    // })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-menu {
  height: 44px;
  line-height: 44px;
}
.el-menu-item {
  height: 44px;
  line-height: 44px;
  width: 240px;
  text-align: center;
}
.el-menu-item > i {
  color: #fff;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.is-active {
  border-bottom-color: #2850a0 !important;
  /* background-color: rgb(40, 80, 160) !important; */
  background-color: #173c87 !important;
}
.el-menu-item {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue